import { style } from '@vanilla-extract/css';
import { vars } from '@/shared/ui/theme';
import { mobile } from '@/shared/ui/theme';

// Luminarium(광원장) shell backdrop container.
export const luminariumContainer = style({
  position: 'absolute',
  inset: '0',
  width: '100%',
  height: '100%',
  pointerEvents: 'none',
  zIndex: vars.elevation.decorative,
  perspective: '400px',
  perspectiveOrigin: '50% 180px',

  '@media': {
    [mobile]: {
      perspective: 'none',
    },
  },
});

// --- WebGL canvas (CyberGridGL renders here) ---

export const cyberGlCanvas = style({
  position: 'absolute',
  inset: 0,
  width: '100%',
  height: '100%',
  pointerEvents: 'none',
});

// CSS fallback grid (when WebGL unavailable) — keeps cyan grid hint without canvas.
// Why 모바일 숨김 없음: 캔버스(cyberGlCanvas)에는 모바일 규칙이 없다. fallback 만 숨기면
// WebGL 없는 폰만 배경을 통째로 잃는 비대칭이 된다 — 같은 축으로 맞춘다.
export const luminariumFallback = style({
  position: 'absolute',
  inset: 0,
  backgroundImage: [
    `repeating-linear-gradient(0deg, transparent, transparent 79px, ${vars.opacityScale.cyan.faint} 79px, ${vars.opacityScale.cyan.faint} 80px)`,
    `repeating-linear-gradient(90deg, transparent, transparent 79px, ${vars.opacityScale.cyan.faint} 79px, ${vars.opacityScale.cyan.faint} 80px)`,
  ].join(', '),
  backgroundSize: '80px 80px',
  pointerEvents: 'none',
});
